import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { SeriesService } from '../series.service';
import { AddSeries } from '../series.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-add-section',
    templateUrl: './add-section.component.html',
    styleUrls: ['./add-section.component.scss'],
})
export class AddSectionComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    serii = [
        { id: -1, name: '--Alegeți--' },
        { id: 1, name: 'Resetare anuală' },
        { id: 2, name: 'Numărătoare continuă' }
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        slug_seq: new FormControl('', [Validators.required]),
        seq_prefix: new FormControl('', []),
        first_number: new FormControl(1, [Validators.required]),
        numar_start: new FormControl('', []),
        numar_end: new FormControl('', []),
        serie_type: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        observatii: new FormControl('', []),
    }, { validators: this.rangeValidator() });

    constructor(
        private dialogRef: MatDialogRef<AddSectionComponent>,
        private requestService: SeriesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    rangeValidator(): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const numarStartControl = formGroup.get('numar_start');
            const numarEndControl = formGroup.get('numar_end');

            if (!numarStartControl || !numarEndControl) {
                return null;
            }

            const numarStart = numarStartControl.value;
            const numarEnd = numarEndControl.value;

            // Dacă ambele câmpuri sunt goale, nu validăm
            if (!numarStart || !numarEnd) {
                // Clear any existing error
                if (numarEndControl.hasError('rangeInvalid')) {
                    numarEndControl.setErrors(null);
                }
                return null;
            }

            const start = Number(numarStart);
            const end = Number(numarEnd);

            // Verificăm dacă start este mai mare sau egal cu end
            if (start >= end) {
                numarEndControl.setErrors({ rangeInvalid: true });
            } else {
                // Clear the error if the range is valid
                if (numarEndControl.hasError('rangeInvalid')) {
                    numarEndControl.setErrors(null);
                }
            }

            return null;
        };
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, slug_seq, seq_prefix, first_number, numar_start, numar_end, serie_type, observatii } = this.form.value;
        const payload: AddSeries = {
            name,
            slug,
            slug_seq,
            seq_prefix,
            first_number,
            numar_start,
            numar_end,
            serie_type,
            observatii
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
